export default __webpack_public_path__ + "static/media/Question.783139d0.svg";